// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const RecoveryCodes  = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 15px;
  
  > div {
    width: 100px;
  }
`;